import { useQuery } from '@tanstack/react-query'
import API from '../../../../../utils/api'

export default function useConektaCards() {
  return useQuery(
    ['conekta-cards'],
    async () => {
      const { data } = await API.getConektaCards()
      return data
    }
  )
}